import "./init-sentry";
import * as Sentry from "@sentry/react";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
import { appRouter } from "@/app/appRouter";
import ReactDOM from "react-dom/client";
import { extend } from "@react-three/fiber";
import { geometry } from "maath";
import { Theme } from "@radix-ui/themes";
import { Provider } from "react-redux";
import { appStore } from "@/app/appStore";
import { BufferControllerProvider } from "@/services/buffer-controller";
import {
  TimelinePlaybackProvider,
  VideoPlaybackProvider,
} from "@/contexts/playback-context";
import { PlaybackMediatorProvider } from "@/contexts/playback-context/playback-mediator-context";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween";
import "zoomist/css";
import "@/shared/base.css";
import "@radix-ui/themes/styles.css";
import "react-day-picker/style.css";
import { ThemeProvider } from "next-themes";

dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(isBetween);
extend(geometry);

async function enableMocking() {
  if (import.meta.env.VITE_MOCK_SERVER !== "true") {
    return;
  }

  const { worker } = await import("../mocks/browser");

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <ThemeProvider attribute="class">
        <Provider store={appStore}>
          <Theme radius="large">
            <BufferControllerProvider>
              <VideoPlaybackProvider>
                <TimelinePlaybackProvider>
                  <PlaybackMediatorProvider>
                    <RouterProvider router={appRouter()} />
                  </PlaybackMediatorProvider>
                </TimelinePlaybackProvider>
              </VideoPlaybackProvider>
            </BufferControllerProvider>
          </Theme>
        </Provider>
      </ThemeProvider>
      <Toaster />
    </Sentry.ErrorBoundary>
  );
});
